export default "__VITE_ASSET__CrfLqBDD__"